// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--f6nUH","mobile":"_4f720283bf--mobile--H6n_n","text":"_4f720283bf--text--Kx0d2","title":"_4f720283bf--title--v0QBL"};